import React from "react";
import { Routes, Route } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "config/stripe";
import { LocationProvider } from "context/Location";

// Auth pages
import FacilityRegisterPage from "pages/auth/FacilityRegisterPage";
import PatientRegisterPage from "pages/auth/PatientRegisterPage";
import ProfessionalRegisterPage from "pages/auth/ProfessionalRegisterPage";
import LoginPage from "pages/auth/LoginPage";
import ResetPasswordPage from "pages/auth/ResetPasswordPage";
import WPAuthHandler from "pages/auth/WPAuthHandler";

// Dashboard pages
import DashboardPage from "pages/dashboard/DashboardPage";
import KijabeDashboard from "pages/dashboard/KijabeDashboard";

// Chat pages
import KijabeChatPage from "pages/KijabeChatPage";
import ChatPageWrapper from "pages/ChatPageWrapper";

// Virtual Queue pages
import PatientRegistration from "components/vaccine/queue/PatientRegistration";

// Legal pages
import PrivacyPolicy from "components/auth/documents/PrivacyPolicy";
import TermsOfUse from "components/auth/documents/TermsOfUse";
import Baa from "components/auth/documents/baa";

// Account pages
import Verify from "components/dashboard/Verify";
import Onboarding from "components/auth/Onboarding";

// Map pages
import MapPage from "pages/map/MapPage";

export const AppRoutes = () => (
  <Routes>
    <Route
      path="/dashboard/*"
      element={
        <Elements stripe={stripePromise}>
          <LocationProvider>
            <DashboardPage />
          </LocationProvider>
        </Elements>
      }
    />

    {/* Auth Routes */}
    <Route path="/register" element={<PatientRegisterPage />} />
    <Route path="/msi/register" element={<PatientRegisterPage />} />
    <Route path="/pro/register" element={<ProfessionalRegisterPage />} />
    <Route path="/facility/register" element={<FacilityRegisterPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/wp-auth-handler" element={<WPAuthHandler />} />

    {/* Account Routes */}
    <Route path="/account" element={<Verify />} />
    <Route path="/onboarding" element={<Onboarding />} />

    {/* Chat Routes */}
    <Route path="/kijabe-dashboard" element={<KijabeDashboard />} />
    <Route path="/kijabe" element={<KijabeChatPage />} />
    <Route path="/chat" element={<ChatPageWrapper />} />

    {/* Virtual Queue Routes */}
    <Route path="/registration/*" element={<PatientRegistration />} />

    {/* Legal Routes */}
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-use" element={<TermsOfUse />} />
    <Route path="/baa" element={<Baa />} />
    {/* <Route path="/chat" element={<PublicChatPage />} /> */}

    {/* Map Routes */}
    <Route path="/" element={<MapPage />} />
    <Route path="*" element={<MapPage />} />
  </Routes>
);
